import initDisableInputHandler from './disableInputHandler.js';

export {
    initDisableInputHandler
};

export default {
    initDisableInputHandler
};
